//const mainDomain = "http://74.235.207.87/PROJECTS/Kipinn/retail-cms/backend/public/";
//const loginRighttest = "http://172.208.33.94:3001/api";
const equaroDomain = "https://api-staging.eqaroguarantees.com/user/v1";

//Live Domain 
const mainDomain = "https://cmsrental.kipinn.in/backend/public/";

const GetAccessToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  if (user) return user.token;

  return null;
};

const GetUserId = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  if (user) return user.userId;

  return null;
};

const Config = {
  AxiosConfig: {
    headers: {
      authorization: `${GetAccessToken()}`,
      id: GetUserId(),
    },
  },

  userType: {
    SUPERADMIN: 1,
    MARKETING: 3,
    OPERATION: 2,
  },
  eqaroDomain: equaroDomain,
  domain: mainDomain,
  apiUrl: mainDomain + "api",
 // sampleapiurl: loginRighttest,
  certificateUrl: mainDomain + "api/upload/CERTIFICATES/",
  docUrl: mainDomain + "api/upload/",
  sessionExpiredTime: 15, // in minutes
  idleTime: 15, // in mins

  roomTypeMapping: {
    1: "Single sharing",
    2: "Double sharing",
    3: "Triple sharing",
    4: "Three plus sharing",
  },

  roomStatus: {
    1: "Vacant",
    2: "Semi occupied",
    3: "Occupied",
    4: "Inactive",
  },

  dueType: {
    RENT: 1,
    SECURITY: 2,
    MAINTENANCE: 3,
    ELECTRICITY: 4,
    REGISTRATION: 5,
    TECH_CHARGES: 6,
    OTHER: 7,
    AGREMENT_CHARGE: 8,
    FOOD: 9,
    FINE: 10,
  },

  //-----TenantType-----
  TENANT_TYPE:{
    FAMILY: 1,
    BACHELOR: 2,
    COMPANY_LEASE: 3,
    ANY: 4,
  },

  LANDLORD_PROPERTY_TYPE: {
    PG: 1,
    APARTMENT_FLAT: 2,
    //VILLA: 3,
    VILLA_INDEPENDENT_FLOOR: 4,
    SHOP_SHOWROOM: 5,
    OFFICE: 6,
    PLOT: 7,
    //WAREHOUSE: 8,
    //SHOWROOM: 9,
    //MIXED_USE: 10,
  },

  INVENTORY_BELONGS_TO: {
    OWNER: 3,
    BROKER: 4,
  },

  INVENTORY_STATUS: {
    AVAILABLE: 1,
    BOOKED: 2,
    LEASED: 3,
    HOLD: 4, 
    MAINTENANCE: 5,
    UNAVAILABLE: 6, 
    DELETE: 7,
  },

  USER_STATUS: {
    PENDING: 1,
    ACTIVE: 2,
    INACTIVE: 3,
    SUSPENDED: 4
  },

  LISTING_TYPE: {
    RENT: 1,
    SALE: 2,
    LEASE: 3,
  },


};

export const preferredTenantOptions = [
  {value: Config.TENANT_TYPE.FAMILY, label: "Family"},
  {value: Config.TENANT_TYPE.BACHELOR, label: "Bachelor"},
  {value: Config.TENANT_TYPE.COMPANY_LEASE, label: "Company Lease"},
  {value: Config.TENANT_TYPE.ANY, label: "Any"},
]

export const landlord_property_type = [
  {
    value: Config.LANDLORD_PROPERTY_TYPE.VILLA_INDEPENDENT_FLOOR,
    label: "Independent Floor/Villa"
  },
  {
    value: Config.LANDLORD_PROPERTY_TYPE.APARTMENT_FLAT,
    label: "Apartment/Flat",
  },
  { 
    value: Config.LANDLORD_PROPERTY_TYPE.PG,
    label: "PG"
  },
  { 
    value: Config.LANDLORD_PROPERTY_TYPE.SHOP_SHOWROOM,
    label: "Showroom/Shop"
  },
  {
    value: Config.LANDLORD_PROPERTY_TYPE.OFFICE,
    label: "Office Space",
  },
];

export const inventoryBelongsTo = [
  // { value: 1, label: "Client" },
  // { value: 2, label: "Staff" },
  { value: Config.INVENTORY_BELONGS_TO.OWNER, label: "Owner" },
  { value: Config.INVENTORY_BELONGS_TO.BROKER, label: "Broker" },
];

export const propertyAvailabilityStatus = [
  { value: Config.INVENTORY_STATUS.AVAILABLE, label: "Available" },
  { value: Config.INVENTORY_STATUS.BOOKED, label: "Booked" },
  { value: Config.INVENTORY_STATUS.LEASED, label: "Leased" },
  { value: Config.INVENTORY_STATUS.HOLD, label: "Hold" },
  { value: Config.INVENTORY_STATUS.UNAVAILABLE, label: "Unavailable" },
  { value: Config.INVENTORY_STATUS.DELETE, label: "Delete" },
];

export const setStatusColor = (status) => {
  const colors = {
    'Available': 'bg-green-100 text-green-700 border-green-200',
    'Booked': 'bg-purple-100 text-purple-700 border-purple-200',
    'Leased': 'bg-blue-100 text-blue-700 border-blue-200',
    'Hold': 'bg-yellow-100 text-yellow-700 border-yellow-200',
    'Unavailable': 'bg-gray-100 text-gray-700 border-gray-200',
    'Delete': 'bg-red-100 text-red-700 border-red-200'
  };
  return colors[status] || 'bg-aqua-100 text-aqua-700 border-aqua-200';
};

export const bhkOptions = [
  { value: 1, label: "1 RK" },
  { value: 2, label: "Studio", },
  { value: 3, label: "1" },
  { value: 4, label: "1.5" },
  { value: 5, label: "2" },
  { value: 6, label: "2.5" },
  { value: 7, label: "3" },
  { value: 8, label: "3.5" },
  { value: 9, label: "4" },
  { value: 10, label: "4.5" },
  { value: 11, label: "5" },
  { value: 12, label: "6" },
  { value: 13, label: "7" },
  { value: 14, label: "8" },
  { value: 15, label: "9" },
];

export const usersStatus = [
  { value: Config.USER_STATUS.PENDING, label: "Pending"},
  { value: Config.USER_STATUS.ACTIVE, label: "Active"},
  { value: Config.USER_STATUS.INACTIVE, label: "Inactive"},
  { value: Config.USER_STATUS.SUSPENDED, label: "Suspended"},
]

export const listing_type = [
  { label: "Rent", value: Config.LISTING_TYPE.RENT },
  { label: "Sale", value: Config.LISTING_TYPE.SALE, disabled: true },
  // {
  //   label: "Lease",
  //   value: Config.LISTING_TYPE.LEASE,
  // },
];

export const dueTypes = [
  { value: 1, label: "Rent" },
  { value: 2, label: "Security" },
  { value: 3, label: "Maintenance" },
  { value: 4, label: "Electricity" },
  { value: 5, label: "Registration" },
  { value: 6, label: "Tech Charges" },
  { value: 7, label: "Other" },
  { value: 8, label: "Agreement Charge" },
  { value: 9, label: "Food" },
  { value: 10, label: "Fine" },
];

export const availableAmenities = [
  { label: "Balcony", value: "balcony" },
  { label: "Ac", value: "ac" },
  { label: "Tv", value: "tv" },
  { label: "Attached Bathroom", value: "attached bathroom" },
  { label: "Wi-Fi", value: "wi-fi" },
  { label: "Washing Machine", value: "washing machine" },
];

export const PaginationLimit = 10;

export const plans = [
  { value: 1, label: "Bronze" },
  { value: 2, label: "Silver" },
  { value: 3, label: "Gold" },
];

export const ForUs = (userId) => {
  if (userId === "e9ca6870-e80a-4df1-9b27-b6986fd6244a") {
    return true;
  }

  return false;
};

export const gTypeOfRoles = [
  { value: "1", label: "Registrar" },
  { value: "2", label: "Customers" },
  { value: "3", label: "Subadmins" },
  { value: "4", label: "Reports" },
];

//---CLIENT CONFIG-------
export const CLIENT_CONFIG_MAP = {
  // 1: {
  //   providerLabel:"PAYU",
  //   types: {
  //     1: {label:"KEY"}
  //   },
  // },

  // 2: {
  //   providerLabel:"CASHFREE",
  //   types: {
  //     2: {label:"SALT"}
  //   },
  // },

  3: {
    providerLabel: "EASEBUZZ",
    types: { 
      3: { label: "SUB ACCOUNT MID" },
    },
  },

  4: {
    providerLabel: "INTERACT",
    types: {
      1: { label: "KEY" },
    },
  },

  5: {
    providerLabel: "APP",
    types: {
      5: { label: "ANDROID" },
      6: { label: "IOS" },
    },
  },

  6: {
    providerLabel: "WATEMPLATE",
    types: {
      7: { label: "WAONBOARDING" },
      8: { label: "FOOTER" },
    },
  },

 7: {
  providerLabel: "INTERNAL",
  types: {
    1: { label: "STAY RULES", richText: true },
    9: { label: "AUTO ASSIGN COMPLAINT", boolean: true },
    10: { label: "NOTIFY PARTNER" },
    11: { label: "BOOKING AMT ENABLED", boolean: true },
    12: { label: "GATEWAY" },
    13: { label: "IS MANUAL MOVEIN", boolean: true },
    14: { label: "MANUAL REMINDER", boolean: true },
    15: { label: "CAN HIDE DUES", boolean: true },
    16: { label: "TENANT APP VERSION" },
  },
},


  8: {
    providerLabel: "TRANSACTION CHARGES",
    types: {
      17: { label: "PER TRANS CHARGE EASEBUZZ" },
      1: { label: "TYPE", transaction:true },
      2: { label: "THRASHOLD" },
    },
  },
};


export default Config;
